export const getDescriptionTextFromHTMLString = (htmlString: string) =>
  htmlString.replace(/<(?:.|\n)*?>/gm, "");
